import { Component, OnInit } from '@angular/core';
import { AuthProvider } from '../../providers/auth';

@Component({
	selector: 'app-not-found',
	templateUrl: './not-found.component.html',
	styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

	constructor(private _auth: AuthProvider) {
		/* this._auth.loginEmitter.subscribe(state => {
			this.loadPage();
		}); */
	}

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// ./src/app/pages/not-found/not-found.component.ts